import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { Container } from '@app/components/Container';
import { ErrorOutcome } from '@app/components/ScheduleInstallation';

type AvailableInstallationDatesFailureProps = {
  goToOverview: () => void;
  refreshPage: () => void;
};

export const AvailableInstallationDatesFailure = ({
  goToOverview,
  refreshPage,
}: AvailableInstallationDatesFailureProps) => {
  const { t } = useTranslation('ScheduleInstallation', {
    keyPrefix: 'UnableToLoadAppointmentTimes',
  });

  return (
    <Container mt="56px">
      <ErrorOutcome goToOverview={goToOverview} refreshPage={refreshPage}>
        <Txt data-cy="error-available-installation-dates-title" mt="48px" mb="12px" variant="heading4">
          {t('title')}
        </Txt>

        <Txt
          variant="bodyLargeRegular"
          data-cy="error-available-installation-dates-description"
          color="subtle"
          mb="40px"
        >
          {t('description')}
        </Txt>
      </ErrorOutcome>
    </Container>
  );
};
